import React, { useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Fn} from "depoto-core";
import {IconName} from "@fortawesome/pro-duotone-svg-icons";
import {generateUuidV4} from "../../utils";

type Props = {
  label?: string
  icon?: IconName
  value?: any
  options?: Array<{ label: string; value: string | number | any }>
  onChange: Fn
}
export const Dropdown: React.FC<Props> = ({ label, icon, value, options, onChange }) => {
  const dropdownRef = useRef<HTMLDetailsElement>(null)

  const onSelect = (e: React.MouseEvent<HTMLLIElement>, val: any) => {
    onChange(val)
    e.currentTarget.closest('.dropdown').removeAttribute('open')
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        dropdownRef.current.removeAttribute('open')
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <details ref={dropdownRef} className="dropdown">
      <summary className="btn btn-base-100 m-1">
        {icon?.length ? (
          <FontAwesomeIcon icon={['far', icon]} className="text-primary mr-2" />
        ) : null}
        {options?.find(c => c.value === value)?.label || label}
        <FontAwesomeIcon icon={['far', 'chevron-down']} className="text-primary ml-4" />
      </summary>
      <ul className="menu dropdown-content bg-base-100 rounded-box z-1 w-40 p-2 shadow-sm">
        {options?.map(o => (
          <li onClick={(e) => onSelect(e, o.value)} key={`${o.value}-${generateUuidV4()}`} className={o.value === value ? 'active' : ''}><a>{o.label}</a></li>
        ))}
      </ul>
    </details>
  )
}
